import(/* webpackMode: "eager", webpackExports: ["ReactQueryDevtools"] */ "/app/node_modules/@tanstack/react-query-devtools/build/modern/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/lightgallery/css/lg-zoom.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/lightgallery/css/lg-fullscreen.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/CitOriginClientProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/lightgallery/css/lightgallery.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/lightgallery/css/lg-video.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/lightgallery/css/lg-thumbnail.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/video.js/dist/video-js.css");
